import React, { useEffect, useState } from 'react'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'
import Typography from '@mui/material/Typography'
import InputField from '../../../../../FormControl/input/InputField'
import Dialog from '../../../../../dialog/Dialog'
import useMarking from '../../../../../../hooks/curriculum/useMarking'
import { Alert } from '@mui/material'
import InputColor from '../../../../../FormControl/input/InputColor'
import { Switch } from '@mui/material'

const MarkingDialog = ({ show, onClose, type, data = {} }) => {
  const { 
    errors: errorsData,
    createMarking,
    updateMarking,
    deleteMarking
  } = useMarking()
  const [form, setInputForm] = useState({})
  const [errors, setInputErrors] = useState(errorsData)
  const [loading, toggleLoading] = useState(false)

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
  }
  const onSave = async (e) => {
    if (!['create', 'edit', 'delete'].includes(type))  {
      setInputErrors({ message: 'Invalid type' })
      return
    }
    e.preventDefault()
    toggleLoading(true)
    try {
      let result = { error: false } 
      if (type === 'create') {
        result = await createMarking(form)
      }
      if (type === 'edit') {
        result = await updateMarking(form._id, form)
      }
      if (type === 'delete') {
        result = await deleteMarking(form._id)
      }
      if (result.error) {
        setInputErrors(result)
      } else {
        onClose()
      }
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => {
    setInputErrors(errorsData)
  }, [errorsData])

  useEffect(() => {
    setInputForm(data || {})
  }, [data])

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      { ['create', 'edit', 'delete'].includes(type) &&
        <ButtonStartIcon
        onClick={onSave}
        color='primary'
        variant='contained'
        disabled={loading}
        loading={loading}
        startIcon={["fal","check"]}
      >
        { type === 'delete' ? 'Confirm' : 'Save'}
      </ButtonStartIcon>
      }
    </>
  );

  return (
    <Dialog
      id={`${type}-marking`}
      show={show} 
      title={`${type} marking`}
      onClose={onClose}
      actions={Actions}
    >
      { type === 'delete'
        ? <Typography>Are you sure you want to delete the marking: <b>{form.name}</b>?</Typography>
        : <div className='flex flex-col gap-4 py-4'>
          <div className='grid grid-cols-4 items-start gap-4'>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Value
            </Typography>
            <div className='col-span-3'>
              { type === 'preview'
                ? <Typography>
                    {form.value}
                  </Typography>
                :  <InputField
                  id='value'
                  name='value'
                  value={form.value}
                  error={errors?.value}
                  helperText={errors?.value}
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  type='number'
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Name
            </Typography>
            <div className='col-span-3'>
              { type === 'preview'
                ? <Typography>
                    {form.name}
                  </Typography>
                :  <InputField
                  id='name'
                  name='name'
                  value={form.name}
                  error={errors?.name}
                  helperText={errors?.name}
                  onChange={(e) => onChange(e.target.name, e.target.value)}
                  fullWidth
                />
              }
            </div>
            <Typography variant='inherit' className='font-bold pl-2' color='primary' align='right' component='p'>
              Primary color
            </Typography>
            <div className='col-span-3'>
              <InputColor
                id='primaryColor'
                name='primaryColor'
                type="color"
                value={form.primaryColor}
                error={errors?.primaryColor}
                disabled={type === 'preview'}
                onChange={(value) => onChange("primaryColor", value)}
                fullWidth
              />
            </div>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Secondary color
            </Typography>
            <div className='col-span-3'>
              <InputColor
                id='secondaryColor'
                name='secondaryColor'
                type="color"
                value={form.secondaryColor}
                error={errors?.secondaryColor}
                disabled={type === 'preview'}
                onChange={(value) => onChange("secondaryColor", value)}
                fullWidth
              />
            </div>
            { type === 'edit' &&
              <>
                { !data.maxValue &&
                  <>
                  <Typography variant='inherit' className='font-bold pl-6' color='primary' align='right' component='p'>
                    Is Min value default
                  </Typography>
                  <div>
                    <Switch
                      id='minValue'
                      color="primary"
                      name="minValue"
                      checked={form?.minValue || false}
                      onChange={data.minValue ? undefined : (e) => onChange("minValue", e.target.checked)}
                    />
                  </div>
                </>
                }
                { !data.minValue &&
                  <>
                    <Typography variant='inherit' className='font-bold pl-4' color='primary' align='right' component='p'>
                      Is Max value default
                    </Typography>
                    <div>
                      <Switch
                        id='maxValue'
                        name="maxValue"
                        color="primary"
                        checked={form?.maxValue || false}
                        onChange={data.maxValue ? undefined : (e) => onChange("maxValue", e.target.checked)}
                      />
                    </div>
                  </>
                }
              </>
            }
          </div>
        </div>
      }
      { errors && errors.message && 
        <Alert 
          severity="error"
          onClose={() => setInputErrors({ message: null })}
        >
          {errors.message}
        </Alert> 
      }
    </Dialog>
  )
}

export default MarkingDialog